<template>
    <div class="article-page">
        <WatsonThemeQuoteFormUsps
            v-if="postTypes.quoteForm || postTypes.usps"
            :content="postTypes"
        />

        <WatsonOrganismContentLayout>
            <template #content>
                <Component
                    :is="componentName(component)"
                    v-for="(component, index) in content"
                    :key="index"
                    :content="component"
                    v-bind="component.attrs.bindData"
                />
            </template>

            <template v-if="showSidebar" #sidebar>
                <watson-theme-cta-block
                    v-bind="postTypes.ctaBlock"
                />
            </template>
        </WatsonOrganismContentLayout>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import componentName from '@utils/component-name';

import WatsonOrganismContentLayout from '@organisms/content-layout/watson-organism-content-layout.vue';
import WatsonThemeCtaBlock from '../../components/cta-block/watson-theme-cta-block.vue';
import WatsonThemeQuoteFormUsps from '../../components/quote-form-usps/watson-theme-quote-form-usps.vue';

const props = defineProps({
    page: {
        type: Object,
        required: true,
    },
    content: {
        type: Array,
        required: true,
    },
    postTypes: {
        type: Object,
        required: true,
    },
});

const showSidebar = computed(() => {
    return !!props.postTypes.ctaBlock;
});
</script>

<style lang="scss">
@use 'article-index';
</style>
